// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qVW8I","productName":"Table_productName__wWo4R"};